import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'en-US',
  // default messages for situations where no platform is present
  messages: {
    'en-US': {
      web: {
        not_found: {
          card_header: 'Page not found!'
        }
      }
    }
  },
  silentTranslationWarn: process.env.NODE_ENV === 'testing'
})

export default i18n



// WEBPACK FOOTER //
// ./src/resources/lang/index.js